import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import { usePages } from "../../pages";
import { Button } from "../../utils/Button";
import { Upload } from "../../utils/Vectors";
import "./UploadSalesDataButtonForCharts.css";

interface UploadSalesDataButtonForChartsProps {
  className?: string;
  height?: string;
}

const UploadSalesDataButtonForCharts = ({
  className = "d-flex justify-content-center align-items-center h-100 upload-sales-button border-0",
  height = "204px",
}: UploadSalesDataButtonForChartsProps) => {
  const history = useHistory();
  const intl = useIntl();
  const pages = usePages();

  const handleUploadClick = () => {
    history.push(pages.SalesDataUpload.url);
  };

  return (
    <div
      className="d-flex align-items-stretch ml-2 rounded bg-white p-2"
      style={{ height, alignSelf: "start" }}
    >
      <Button
        className={className}
        onClick={handleUploadClick}
        variant="secondary"
      >
        <div>
          <Upload width={20} />
          <div className="d-flex align-items-center" style={{ padding: "8px" }}>
            {intl.formatMessage({
              id: "components/pages:SalesDashBoard/UploadSalesDataButtonForCharts/upload",
              defaultMessage: "Upload",
            })}
          </div>
        </div>
      </Button>
    </div>
  );
};

export default UploadSalesDataButtonForCharts;
